<template>
    <div class="login-wrap">
        <div class="login-top">
            <div class="imglogo">
                <img src="@/assets/img/loginbg.png" />
            </div>
            <div class="ms-login">
                <div class="ms-title">
                    <img src="@/assets/img/kp-logo.png" />
                    <label>{{$t('COMMON_PROJECT_NAME')}}</label>
                </div>
                <el-form
                    :model="param"
                    :rules="rules"
                    ref="login"
                    label-width="0px"
                    class="ms-content"
                >
                    <el-form-item class="item checkAccount" prop="userName">
                        <p class="title">Change user name</p>
                        <el-input
                            @keyup.enter.native="submitForm()"
                            v-model="param.userName"
                            :placeholder="$t('login_new_userName')"
                        ></el-input>
                    </el-form-item>
                    <div class="footer-login">
                        <el-button
                            class="login-btn login-item back"
                            type="primary"
                            @click="backLogin()"
                        >{{$t('login_btn_back')}}</el-button>
                        <el-button
                            :loading="loginLoading"
                            class="login-btn login-item save"
                            type="primary"
                            @click="submitForm()"
                        >{{$t('login_btn_confirm')}}</el-button>
                    </div>
                </el-form>
            </div>
        </div>
        <v-bottom></v-bottom>
    </div>
</template>

<script>
import API from '@/api'
import vBottom from '@/components/common/Bottom.vue'
import { mapGetters } from 'vuex'

export default {
    data() {
        return {
            user: '',
            loginLoading: false,
            param: {
                userName: ''
            }
        }
    },
    computed: {
        ...mapGetters('common', {
            getUser: 'getUser'
        }),
        rules() {
            const rules = {
                userName: [{ required: true, message: this.$t('FORM_VALIDATE_REQUIRED'), trigger: 'blur' }]
            }
            return rules
        }
    },
    methods: {
        submitForm() {
            this.$refs.login.validate(valid => {
                if (valid) {
                    this.loginLoading = true
                    let params = {
                        userAccount: this.userAccount,
                        userName: this.param.userName
                    }
                    API.common
                        .updateUserName(params)
                        .then(res => {
                            if (res.code == '1') {
                                this.loginLoading = false
                                this.user.userName = this.param.userName
                                localStorage.setItem('userInfo', JSON.stringify(this.user))
                                this.$message.success(this.$t('msg_send_success'))
                                this.$router.push('/')
                            }
                        })
                        .catch(err => {})
                        .finally(() => {
                            this.loginLoading = false
                        })
                }
            })
        },
        backLogin() {
            this.$router.push('/client')
        }
    },
    mounted() {
        this.user = this.getUser
        this.param.userName = this.user.userName
        this.userAccount = this.user.userAccount
    },
    components: {
        vBottom
    }
}
</script>

<style scoped>
.login-wrap {
    position: relative;
    width: 100%;
    height: 100%;
}

.login-top {
    position: relative;
    width: 100%;
    height: calc(100% - 80px);
    background-color: #ffffff;
}

.imglogo img {
    width: 1036px;
}

.ms-title {
    width: 100%;
}

.ms-title img {
    width: 82px;
    height: 34px;
    display: block;
    margin: 0 auto;
    margin-top: 20px;
}

.ms-title label {
    display: block;
    width: 100%;
    text-align: center;
    font-family: 'KPMG Light', 'KPMG';
    font-size: 36px;
    color: #00338d;
    margin-top: 10px;
}

.ms-login {
    position: absolute;
    right: 15%;
    top: 9%;
    width: 411px;
    height: 440px;
    border: 1PX solid #a8c8e7;
    background: rgba(255, 255, 255, 0.3);
    overflow: hidden;
}

.ms-content .item {
    margin-top: 2px;
}

.ms-content .title {
    font-weight: 400;
    font-style: normal;
    font-size: 14px;
    color: #005eb8;
}

.login-tips {
    display: block;
    margin-top: 16px;
    font-weight: 400;
    font-style: normal;
    font-size: 14px;
    color: #005eb8;
    text-align: center;
}

.footer-login {
    margin: 0 auto;
    width: 320px;
    height: 40px;
    margin-top: 18px;
}

.login-item {
    width: 146px;
    height: 40px;
    border: none;
    border-radius: 0;
    background-color: #005eb8;
}

.back {
    color: #333;
    background-color: rgba(240, 240, 240, 1);
}

.save {
    margin-left: 28px !important;
}

.login-item:hover {
    background-color: #0091da;
}
</style>
